import styles from "./EscalatedIncidentsModal.module.css";
import PropTypes from "prop-types";
import { Modal } from "@wwg/ui";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import closeButtonImage from "./xButton.PNG";
import { action } from "@storybook/addon-actions";

/**
 *
 * Modal that opens when view is clicked on an escalated incident item. Admins can view the reason for the escalation and any related notes the Case Owner added. (There is a select displayed, but the documentation says it should just display the reason)
 *
 */

export function EscalatedIncidentsModal({ userInfo, isOpen, onView, onClose }) {
  const [reason, setReason] = useState("");
  const [actions, setActions] = useState("");

  useEffect(() => {
    if (userInfo?.escalation) {
      setReason(userInfo.escalation.reason);
      setActions(userInfo.escalation.actionsNeeded);
    }
  }, [userInfo]);

  return (
    <>
      <Modal
        visible={isOpen}
        children={
          <div className={styles.container}>
            <img
              src={closeButtonImage}
              className={styles.closeButton}
              onClick={onClose}
              alt=""
            />
            <div className={styles.header}>Escalated Incidents</div>
            <div className={styles.hr} />

            <div className={styles.title}>
              Why is this issue being escalated?
            </div>
            <input
              type="text"
              className={styles.input}
              placeholder="No Reason"
              onChange={(e) => setReason(e.target.value)}
              value={reason}
              disabled
            />

            <div className={styles.title}>What actions need to be taken?</div>
            <textarea
              className={styles.textarea}
              placeholder="No Actions"
              onChange={(e) => setActions(e.target.value)}
              value={actions}
              disabled
            >
              {actions}
            </textarea>
            <Link to={`/security/incident/${userInfo.id}`}>
              <div className={styles.buttonContainer}>
                <button onClick={onView} className={styles.button}>
                  View Incident
                </button>
              </div>
            </Link>
          </div>
        }
      />
    </>
  );
}

EscalatedIncidentsModal.propTypes = {
  isOpen: PropTypes.bool,
  onView: PropTypes.func,
  onClose: PropTypes.func,
};
